import React, {useState} from 'react';
import {PlusOutlined} from '@ant-design/icons';
import {Button, Form, Input, Modal} from 'antd';
import {createD365ExpenseCode} from '../../api/d365Api';

const ExpenseCodeButton = ({
                               disabled,
                               onCompleted,
                               title,
                               email,
                               style
                           }) => {
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [form] = Form.useForm();

    const FORM_EXPENSE_CODE = 'input';

    const _createExpenseCode = async () => {
        try {
            setLoading(true);
            const expenseCode = form.getFieldValue(FORM_EXPENSE_CODE);
            const response = await createD365ExpenseCode(expenseCode, email);
            onCompleted(response, "created");
        } catch (e) {
            console.error(`Could not create Expense Code`);
        } finally {
            setLoading(false);
            setShowModal(false);
            form.resetFields();
        }
    };


    return (
        <>
            <Button onClick={() => setShowModal(true)} loading={loading} disabled={disabled}
                    icon={<PlusOutlined/>} style={style}>
                {title}
            </Button>
            <Form
                name={`expense_code`}
                form={form}
                onFinish={_createExpenseCode}
                labelCol={{span: 6}}
            >
                <Modal
                    title={`Input Expense Code (Pattern - [B/N][E/I]1234)`}
                    open={showModal}
                    onOk={() => setShowModal(false)}
                    onCancel={() => setShowModal(false)}
                    footer={[
                        <Button key="cancel" onClick={() => setShowModal(false)}>Cancel</Button>,
                        <Button key="submit" type="primary" onClick={() => form.submit()}
                                loading={loading}>Submit</Button>
                    ]}
                >
                    <Form.Item
                        label="Expense Code"
                        name={FORM_EXPENSE_CODE}
                        rules={[{required: true, pattern: new RegExp("[BN][EI]\\d{4}"),
                            message: "Code does not match pattern"}]}
                    >
                        <Input
                            type="text"
                            placeholder="Expense Code"
                        />
                    </Form.Item>
                </Modal>
            </Form>
        </>
    );
};

export {ExpenseCodeButton};